import { TextFieldWrapper } from "../style/ConditionSelector.styled";

export default function TextFieldView () {
    return (
        <TextFieldWrapper>
            <div>* 선택된 카테고리의 서브 카테고리가 모두 조회됩니다.</div>
            <div>* 서브 카테고리를 선택해 상품 순위를 확인할 수 있습니다.</div>
        </TextFieldWrapper>
    )
}